import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeDuration' })
export class TimeDuration implements PipeTransform {
  transform(value: number): string {
    let ds: string;
    const duration = new Date(value * 1000);
    const hours = duration.getUTCHours();
    const minutes = duration.getUTCMinutes();
    const seconds = duration.getUTCSeconds();

    if (value < 3600) {
      ds = `${minutes} min ${seconds} sec`;
    } else {
      ds = `${hours} h ${minutes} min ${seconds} sec`;
    }

    return ds;
  }
}
